import { render, staticRenderFns } from "./FlashArticle.vue?vue&type=template&id=1d57b685&"
import script from "./FlashArticle.vue?vue&type=script&lang=js&"
export * from "./FlashArticle.vue?vue&type=script&lang=js&"
import style0 from "./FlashArticle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/m3/deti-ekarta43-ru/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VFlex,VIcon,VLayout,VSpacer,VSubheader})
